module.exports = __webpack_public_path__ + "img/bnbseguros-contacto.7bb01fb2.jpg";